import Funnel from "@/components/Funnel";
import Seo from "@/lib/seo/Seo";
import { getSeoForPath } from "@/lib/seo/routes.mjs";

const QUESTIONS = [
  {
    label: "What type of business do you own?",
    options: [
      "Restaurant / Deli",
      "Convenience Store",
      "Retail Store",
      "Smoke Shop / Market",
      "Service Business",
      "Other",
    ],
  },
  {
    label: "How much do you process monthly in card sales?",
    options: [
      "Under $10,000",
      "$10,000 – $25,000",
      "$25,000 – $50,000",
      "$50,000 – $100,000",
      "Over $100,000",
      "Not sure",
    ],
  },
  {
    label: "Are you currently paying monthly processing fees?",
    options: [
      "Yes",
      "No",
      "I am on cash discount already",
      "Not sure",
    ],
  },
  {
    label: "Would you like to see how much your business could save with a cash discount program?",
    options: [
      "Yes, show me potential savings",
      "Maybe, I’d like to learn more",
      "I already use cash discount",
      "Not sure yet",
    ],
  },
];

export default function CashDiscountFunnel() {
  return (
    <div data-prerender-ready="true">
      <Seo {...getSeoForPath("/cash-discount-savings")} />
      <Funnel
        slug="cash-discount-savings"
        accentBadge="Cash Discount Savings"
        hero="See How Much Your Business Could Save With Cash Discount"
        subtitle="Answer a few quick questions and Swipetronics will help you understand if a cash discount program makes sense for your business."
        questions={QUESTIONS}
        finalTitle="Get Your Cash Discount Savings Review"
        eventName="CashDiscountLead"
      />
    </div>
  );
}
